/**
 * @generated SignedSource<<8071a0766208b782d3e94ca4276ce3e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LoginStatus = "BlockedByAdmin" | "Deactivating" | "GoogleApiAccessDisabled" | "GoogleContactSharingDisabled" | "InsufficientScopes" | "NoCrawl" | "PersonalEmail" | "SecondaryDomainUsed" | "Success" | "WaitlistedEmail" | "%future added value";
export type OrganizationOperationResultEnum = "Add" | "Create" | "Delete" | "Fetch" | "%future added value";
export type RefreshTokenResultOperationEnum = "Create" | "Fetch" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type UserStatusEnum = "Active" | "Preview" | "Restricted" | "%future added value";
export type VerificationType = "Slack" | "%future added value";
export type LoginUserMutationInput = {
  clientMutationId?: string | null;
  deviceIdAndRegistrationToken?: DeviceIdAndRegistrationToken | null;
  googleOfflineCode: string;
  verificationType?: VerificationType | null;
};
export type DeviceIdAndRegistrationToken = {
  deviceId: string;
  registrationToken: string;
};
export type LoginUserMutation$variables = {
  input: LoginUserMutationInput;
};
export type LoginUserMutation$data = {
  readonly loginUser: {
    readonly clientMutationId: string | null;
    readonly verifyCodeResult: boolean | null;
    readonly verifyCodeMessage: string | null;
    readonly loginStatus: LoginStatus;
    readonly operation: RefreshTokenResultOperationEnum | null;
    readonly orgOperation: OrganizationOperationResultEnum | null;
    readonly viewer: {
      readonly id: string;
      readonly user: {
        readonly id: string;
        readonly status: UserStatusEnum | null;
        readonly emails: ReadonlyArray<string>;
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly externalImageUrl: string | null;
        readonly createdTime: any | null;
        readonly members: ReadonlyArray<{
          readonly value: string | null;
          readonly scope: {
            readonly type: UrnType | null;
            readonly value: string | null;
          } | null;
        } | null> | null;
        readonly orgs: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly primaryOrgCalendar: string;
              readonly primaryOrgEmail: string;
              readonly id: string;
              readonly experiments: ReadonlyArray<string | null> | null;
              readonly name: string | null;
              readonly createdTime: any | null;
              readonly userPerson: {
                readonly profile?: {
                  readonly givenName: string | null;
                  readonly familyName: string | null;
                  readonly externalImageUrl: string | null;
                } | null;
              } | null;
              readonly flowStates: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly flowKey: string | null;
                    readonly current: {
                      readonly state: string | null;
                      readonly percentComplete: number | null;
                      readonly errorMessage: string | null;
                    } | null;
                    readonly pending: {
                      readonly state: string | null;
                      readonly percentComplete: number | null;
                      readonly errorMessage: string | null;
                    } | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly workingGroups: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                  } | null;
                } | null> | null;
              };
            } | null;
          } | null> | null;
        };
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"WebAppNav_viewer">;
    } | null;
  } | null;
};
export type LoginUserMutation = {
  variables: LoginUserMutation$variables;
  response: LoginUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifyCodeResult",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifyCodeMessage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginStatus",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "operation",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgOperation",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emails",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "givenName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "familyName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalImageUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdTime",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryOrgCalendar",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryOrgEmail",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "experiments",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Person",
  "abstractKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flowKey",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentComplete",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v27 = [
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/)
],
v28 = [
  (v8/*: any*/)
],
v29 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "WorkingGroupConnection",
  "kind": "LinkedField",
  "name": "workingGroups",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkingGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkingGroup",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v28/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "workingGroups(first:1000000)"
},
v30 = [
  (v8/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/)
],
v31 = [
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoginUserMutationPayload",
        "kind": "LinkedField",
        "name": "loginUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WebAppNav_viewer"
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Urn",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Urn",
                        "kind": "LinkedField",
                        "name": "scope",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "concreteType": "OrgConnection",
                    "kind": "LinkedField",
                    "name": "orgs",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrgEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Org",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v8/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "userPerson",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v17/*: any*/),
                                "concreteType": "FlowStateConnection",
                                "kind": "LinkedField",
                                "name": "flowStates",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlowStateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FlowState",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v23/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStatus",
                                            "kind": "LinkedField",
                                            "name": "current",
                                            "plural": false,
                                            "selections": (v27/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStatus",
                                            "kind": "LinkedField",
                                            "name": "pending",
                                            "plural": false,
                                            "selections": (v27/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "flowStates(first:1000000)"
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "orgs(first:1000000)"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoginUserMutationPayload",
        "kind": "LinkedField",
        "name": "loginUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "concreteType": "FlowStateConnection",
                    "kind": "LinkedField",
                    "name": "flowStates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowStateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlowState",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previousState",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "current",
                                "plural": false,
                                "selections": (v30/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "pending",
                                "plural": false,
                                "selections": (v30/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "flowStates(first:1000000)"
                  },
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "concreteType": "OrgConnection",
                    "kind": "LinkedField",
                    "name": "orgs",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrgEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Org",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "userPerson",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                  },
                                  (v22/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v17/*: any*/),
                                "concreteType": "FlowStateConnection",
                                "kind": "LinkedField",
                                "name": "flowStates",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlowStateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FlowState",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v23/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStatus",
                                            "kind": "LinkedField",
                                            "name": "current",
                                            "plural": false,
                                            "selections": (v31/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStatus",
                                            "kind": "LinkedField",
                                            "name": "pending",
                                            "plural": false,
                                            "selections": (v31/*: any*/),
                                            "storageKey": null
                                          },
                                          (v8/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "flowStates(first:1000000)"
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "orgs(first:1000000)"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Urn",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Urn",
                        "kind": "LinkedField",
                        "name": "scope",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v15/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7e76f939546e0c9d7fa56dfca8bc4d3e",
    "id": null,
    "metadata": {},
    "name": "LoginUserMutation",
    "operationKind": "mutation",
    "text": "mutation LoginUserMutation(\n  $input: LoginUserMutationInput!\n) {\n  loginUser(input: $input) {\n    clientMutationId\n    verifyCodeResult\n    verifyCodeMessage\n    loginStatus\n    operation\n    orgOperation\n    viewer {\n      ...WebAppNav_viewer\n      id\n      user {\n        id\n        status\n        emails\n        givenName\n        familyName\n        externalImageUrl\n        createdTime\n        members {\n          value\n          scope {\n            type\n            value\n            id\n          }\n          id\n        }\n        orgs(first: 1000000) {\n          edges {\n            node {\n              primaryOrgCalendar\n              primaryOrgEmail\n              id\n              experiments\n              name\n              createdTime\n              userPerson {\n                __typename\n                ... on Person {\n                  profile {\n                    givenName\n                    familyName\n                    externalImageUrl\n                  }\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n              flowStates(first: 1000000) {\n                edges {\n                  node {\n                    flowKey\n                    current {\n                      state\n                      percentComplete\n                      errorMessage\n                      id\n                    }\n                    pending {\n                      state\n                      percentComplete\n                      errorMessage\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              workingGroups(first: 1000000) {\n                edges {\n                  node {\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment WebAppNav_viewer on Viewer {\n  id\n  user {\n    givenName\n    familyName\n    externalImageUrl\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          id\n          flowKey\n          previousState\n          current {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n          pending {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          primaryOrgCalendar\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3be4860dff39c9a7fb5d73b593edcd4";

export default node;
